module.exports = __webpack_public_path__ + "static/media/heart-broken.00c83e10.svg";